<template>
  <div class="root mine">
    <p>{{ list }}</p>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "mine",
  data() {
    return {
      list: "流失提醒",
    };
  },
};
</script>
<style lang>
</style>
